import React, { useCallback, useEffect, useState } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import TypographyPreferencesInlineV2 from "./TypographyPreferencesInlineV2";

export default function TypographyEditorDialogV1({ open, onClose, onSaved, references, onStateChanged, returnFocusRef }) {
  const [draft, setDraft] = useState({ dirty: false, busy: false });
  const [confirmClose, setConfirmClose] = useState(false);
  const [actionArea, setActionArea] = useState(null);
  const draftChanged = useCallback((next) => setDraft(next), []);
  const close = () => {
    if (draft.busy) return;
    if (draft.dirty) setConfirmClose(true);
    else onClose();
  };
  useEffect(() => {
    if (!draft.dirty) return undefined;
    const protect = (event) => { event.preventDefault(); event.returnValue = ""; };
    window.addEventListener("beforeunload", protect);
    return () => window.removeEventListener("beforeunload", protect);
  }, [draft.dirty]);

  return <Dialog.Root open={open} onOpenChange={(next) => { if (!next) close(); }}>
    <Dialog.Portal>
      <Dialog.Overlay className="fixed inset-0 z-50 bg-[#2B211A]/30" />
      <Dialog.Content
        className="bs-action-workspace fixed inset-0 z-50 flex min-w-0 flex-col overflow-hidden bg-[#FFFDF9] text-[#2B211A] shadow-xl sm:inset-auto sm:left-1/2 sm:top-1/2 sm:max-h-[90dvh] sm:w-[calc(100%-3rem)] sm:max-w-3xl sm:-translate-x-1/2 sm:-translate-y-1/2 sm:rounded-3xl sm:border sm:border-[#DFD2C0]"
        onCloseAutoFocus={(event) => { event.preventDefault(); returnFocusRef.current?.focus(); }}
        data-testid="typography-editor-dialog">
        <header className="flex shrink-0 items-start justify-between gap-4 border-b border-[#E8DCCB] px-5 py-4">
          <div>
            <Dialog.Title className="font-serif text-[26px]">Шрифты и ориентиры</Dialog.Title>
            <Dialog.Description className="mt-1 text-[12px] text-[#655141]">Выбери шрифт и назначь ему роль.</Dialog.Description>
          </div>
          <button type="button" onClick={close} disabled={draft.busy} aria-label="Закрыть" className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-full border border-[#DFD2C0] disabled:opacity-50" data-testid="typography-editor-close"><X size={18} /></button>
        </header>
        {confirmClose && <div role="alert" className="shrink-0 border-b border-[#E8DCCB] bg-[#F1E9DD] p-4" data-testid="typography-editor-discard">
          <p className="text-[13px]">Закрыть без сохранения?</p>
          <div className="mt-2 flex flex-wrap gap-2">
            <button type="button" onClick={() => setConfirmClose(false)} className="min-h-11 rounded-full border border-[#CDBBA4] px-4 text-[12px]">Продолжить редактирование</button>
            <button type="button" onClick={onClose} className="min-h-11 rounded-full bg-[#3D2A20] px-4 text-[12px] text-[#FFF8ED]">Закрыть без сохранения</button>
          </div>
        </div>}
        <div className="min-h-0 min-w-0 flex-1 overflow-y-auto overscroll-contain p-4 sm:p-5">
          <TypographyPreferencesInlineV2 references={references} showSystems={false} compact
            actionArea={actionArea} onDraftStateChanged={draftChanged} onStateChanged={onStateChanged} onSaved={onSaved} />
        </div>
        <div ref={setActionArea} className="min-w-0 shrink-0 bg-[#FFFDF9]" data-testid="typography-editor-action-area" />
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>;
}
